import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'cd-image-update-workflow',
});
export const pickShaRouteRef = createRouteRef({
  id: 'pick-sha',
});

export const updateServiceRouteRef = createRouteRef({
  id: 'update-service',
});

export const previewRouteRef = createRouteRef({
  id: 'previewPage',
});

export const serviceShaRouteRef = createRouteRef({
  id: 'serviceShaPage',
});